import lodash from 'lodash';

import { POLL_TYPE } from './../ricos-content';
import type { RichContent } from './../ricos-schema/legacy/wix/rich_content/v1';
import type { AvailableExperiments, EditorPlugin, ViewerPlugin } from './../ricos-types';
import type { GetWixClientPromise } from './../_shared/request-service-provider/use-get-wix-client-promise';

import type { BISettings } from '.';
import { biStrategy } from './biStrategy/biStrategy';
import iframeSandboxDomainStrategy from './iframeSandboxDomainStrategy/iframeSandboxDomainStrategy';
import pollsStrategy from './pollsStrategy/pollsStrategy';
import {
  hasPlugin as hasPluginInPlugins,
  hasPollsPluginInContent,
  parseInstance,
} from './services';
import urlResolutionStrategy from './urlResolutionStrategy/urlResolutionStrategy';

type RunStrategies = {
  experiments?: {
    ricosFeatures?: Record<string, never> | AvailableExperiments;
    wixRicosFeatures?: Record<string, never> | AvailableExperiments;
  };
  plugins: EditorPlugin[] | ViewerPlugin[] | undefined;
  instance: string;
  wixRicosVersion: string;
  ricosVersion: string;
  biSettings: BISettings;
  getWixClientPromise: GetWixClientPromise;
  msid?: string;
  viewer?: boolean;
  content?: RichContent;
};

export const runStrategies = ({
  experiments = {},
  plugins,
  instance,
  wixRicosVersion,
  ricosVersion,
  biSettings,
  getWixClientPromise,
  msid = '',
  viewer = false,
  content,
}: RunStrategies) => {
  const hasPlugin = (pluginType: string) => hasPluginInPlugins(pluginType, plugins);

  const { metaSiteId: instanceMsid, appDefId } = parseInstance(instance);
  const metaSiteId = instanceMsid || msid;

  const { ricosFeatures, wixRicosFeatures } = experiments;

  const shouldUsePollStrategy =
    hasPlugin(POLL_TYPE) && (!viewer || (viewer && hasPollsPluginInContent(content)));

  return lodash.merge(
    { experiments: ricosFeatures },
    biStrategy(appDefId, metaSiteId, wixRicosVersion, ricosVersion, biSettings, wixRicosFeatures),
    urlResolutionStrategy(hasPlugin, instance, metaSiteId, wixRicosFeatures),
    shouldUsePollStrategy && pollsStrategy(instance, getWixClientPromise),
    iframeSandboxDomainStrategy(metaSiteId),
    wixRicosFeatures
  );
};

export const runStrategiesWithCommonUtils = (props: RunStrategies) => ({
  strategies: runStrategies(props),
});
